<script>
    import { createEventDispatcher } from 'svelte';
    import RadioSubcategory from './RadioSubcategory.svelte';
    import ChoiceSubcategory from './ChoiceSubcategory.svelte';
    import MultipleChoiceSubcategory from './MultipleChoiceSubcategory.svelte';
    import { Categories } from '../../ui_elements/enums';
    import { getLocalStorageItem, post, setLocalStorageItem } from '../../utility.js';

    export let subcategoryID;
    export let categoryName;
    export let isAdmin = false;
    export let questions;

    export function triggerSubmission(validate) {
        console.log("checking child component: " + validate);
        return subTrigger(validate);
    }

    let answers = {};
    let err_message = "";
    let showErrors = false;
    const dispatch = createEventDispatcher();

    function subTrigger(validate) {
        showErrors = true;
        if (validate && !validateAnswers()) return false;
        try {
            const data = post('submit-answers/', {answers});
            console.log(data);
        } catch (error) {
            console.error('Error submitting data:', error);
            return false;
        }
        // modify local storage to save new answers
        updateLocalStorage();
        return true;
    }

    function handleAnswerChange(event) {
        answers = event.detail.answers;
    }

    function updateLocalStorage() {
        const questionnaireAnswers = getLocalStorageItem('questionnaireAnswers') || {};
        questionnaireAnswers[subcategoryID] = answers;
        setLocalStorageItem('questionnaireAnswers', questionnaireAnswers);
    }

    function validateAnswers() {
        // check if all questions have been answered
        if (!isMultipleChoiceSubcategory() && questions.length !== Object.keys(answers).length) {
            err_message = 'Bitte wähle für alle Fragen eine Antwort aus.';
            return false;
        }
        err_message = '';
        return true;
    }

    function isRadioSubcategory() {
        return [Categories.INTERESSEN, Categories.FAEHIGKEITEN, Categories.SCHULFAECHER, Categories.SCHULNOTEN, Categories.FEEDBACK].includes(categoryName);
    } 

    function isChoiceSubcategory() {
        return categoryName === Categories.ARBEITSVERHALTEN;
    }

    function isMultipleChoiceSubcategory() {
        return questions[0].question_type_id === "MULTIPLE_CHOICE";
    }
</script>

<main>
    {#if questions}
        {#if isRadioSubcategory()}
            <RadioSubcategory {questions} {subcategoryID} {categoryName} {isAdmin} {showErrors} on:answerChange={handleAnswerChange}/>
        {:else if isChoiceSubcategory()}
            <ChoiceSubcategory {questions} {subcategoryID} on:answerChange={handleAnswerChange}/>
        {:else} 
            <MultipleChoiceSubcategory {questions} {subcategoryID} on:answerChange={handleAnswerChange}/>
        {/if}

        {#if err_message}
            <div class="text-red-600">{err_message}</div>
        {/if}

    {:else}
        <div>Loading...</div>
    {/if}
</main>

